'use client';

import type { LotteryOptionGoodsForm } from '../../types';
import styles from './OptionNamedBar.module.scss';

export type OptionNamedBarProps = {
  optionFormData?: LotteryOptionGoodsForm;
  filledInputCount: number;
  onGoBack: () => void;
  onSubmit: () => void;
};

function OptionNamedBar({ optionFormData, filledInputCount, onGoBack, onSubmit }: OptionNamedBarProps) {
  // 入力完了ボタンのボタン色を取得
  const getConfirmButtonColor = (
    currentOptionFormData: LotteryOptionGoodsForm | undefined,
    currentFilledInputCount: number,
  ): 'gray' | 'primary' => {
    if (!currentOptionFormData) return 'gray';
    const remainingCount = Math.max(0, currentOptionFormData.totalAcquiredCount - currentFilledInputCount);
    return remainingCount > 0 ? 'gray' : 'primary';
  };

  // 入力完了ボタンを無効にするかどうかの判定
  const isConfirmButtonDisabled = (
    currentOptionFormData: LotteryOptionGoodsForm | undefined,
    currentFilledInputCount: number,
  ): boolean => {
    if (!currentOptionFormData) return true;
    const remainingCount = Math.max(0, currentOptionFormData.totalAcquiredCount - currentFilledInputCount);
    return remainingCount > 0;
  };

  const confirmButtonColor = getConfirmButtonColor(optionFormData, filledInputCount);
  const confirmButtonDisabled = isConfirmButtonDisabled(optionFormData, filledInputCount);

  return (
    <div className={styles.componentStyle}>
      <div className={styles.container}>
        <div className={styles.buttonWrapper}>
          <button type='button' className={styles.backButton} onClick={onGoBack}>
            戻る
          </button>
          <div className={styles.confirmButtonWrapper}>
            <button
              type='button'
              className={styles.confirmButton}
              onClick={onSubmit}
              color={confirmButtonColor}
              disabled={confirmButtonDisabled}
            >
              入力を完了する
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OptionNamedBar;
